import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { appConfig } from '@/config/appConfig.ts';
import { ROUTES } from '@/config/routes.ts';
import { useHydration } from '@/hooks/useHydration';
import { useAuthStore } from '@/stores/auth-store';
import { Role } from '@shared';

interface RoleGuardProps {
  roles: Role[] | Role;
  children: ReactNode;
}

export function RoleGuard({ roles, children }: RoleGuardProps) {
  const hydrated = useHydration();
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const hasRole = useAuthStore(s => s.hasRole);

  // Mode dev sans redirection
  if (!appConfig.enableLoginRedirect) {
    return <>{children}</>;
  }

  // Zustand lit encore le localStorage → on ne redirige pas prématurément
  if (!hydrated) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (!hasRole(roles)) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return <>{children}</>;
}
